export const REMOVE_BLOCK_PARKING = `
  mutation ($facilityParkingReservationId: Int!) {
    cancelParkingReservation(facilityParkingReservationId: $facilityParkingReservationId) {
        id
    }
  }
`
